import { render, staticRenderFns } from "./OrderAvisoTab.vue?vue&type=template&id=655abb49&"
import script from "./OrderAvisoTab.vue?vue&type=script&lang=js&"
export * from "./OrderAvisoTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports